
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import InlineXNumber from 'vux/src/components/inline-x-number/index.vue'

import { Checkbox, CheckboxGroup, Cell, CellGroup } from 'vant'
import {
getPartyVoteList,
addVotePartyVotelog,
addCount
} from '@/api/youzheng'
import { nowInDateBetwen } from '@/libs/utils'
import { operateCreditlist } from '@/api/user'
import Storage from '@/storage'
export default {
props: ['partyObj'],
directives: {
TransferDom
},
components: {
vanCheckbox: Checkbox,
vanCheckboxGroup: CheckboxGroup,
vanCell: Cell,
vanCellGroup: CellGroup,
XDialog,
Flexbox,
FlexboxItem,
InlineXNumber
},
data () {
return {
baseUrl: this.$config.baseUrl,
obj: [],
voted: 0, // 已投票数
showDialog: false,
partyid: this.$route.params.artid,
searchvalue: '',
noResult: false,
page: 1,
rows: 30,
num: '',
loadnum: '',
dialogobj: {},
dialogobjIndex: '',
votenum: 1,
voteTotal: 0, // 可投票数量
moremsg: '点击加载更多',
status: 0, // 0还未开始，1正在进行，-1结束
scroll: 0,
showbtn: true,
searchlist: '',
mhsearch: false,
ischoose: false,
checkboxModel: [] 
}
},
computed: {
accountid () {
return this.$store.state.user.accountid
},
userid () {
return this.$store.state.user.userid
}
},
watch: {
searchvalue: {
handler (newVal, oldVal) {
if (newVal.length !== 0 && this.ischoose === false) {
this.mhsearch = true
getPartyVoteList({
partyid: this.partyid,

username: newVal,
page: this.page,
rows: this.rows
}).then(data => {
if (data.success) {
this.searchlist = data.obj

}
})
} else if (newVal.length === 0 || this.ischoose === true) {
this.searchlist = ''
this.mhsearch = false
}
}
}
},
activated () {
window.scroll(0, this.scroll)
},
mounted () {
this.status = nowInDateBetwen(
this.partyObj.votestartdate,
this.partyObj.voteenddate
)
this.loadList()
this.getCount()
},
methods: {
toggle (index) {
this.$refs.checkboxes[index].toggle()
},
loadList () {
getPartyVoteList({
partyid: this.partyid,

username: this.searchvalue,
page: this.page,
rows: this.rows
}).then(data => {
if (!data.obj) return
this.num = data.msg
if (this.loadnum === '') {
this.loadnum = this.num
} else { this.num = this.loadnum }
if (data.obj.length <= 0 && this.page === 1) {
this.obj = []
this.noResult = true
} else if (data.obj.length > 0 && this.page === 1) {
this.obj = data.obj
} else {
this.noResult = false
this.obj = this.obj.concat(data.obj)
this.moremsg = '点击加载更多'
}
})
},
loadmore () {
this.moremsg = '正在加载中'
this.page++
this.loadList()
},

vote () {
if (this.voteTotal == 0) {
this.$vux.toast.text('您已投过票')
return false
}
if (this.checkboxModel.length < this.partyObj.voteMin) {
this.$vux.toast.text(
'请最少选择' +
this.partyObj.voteMin +
'项，已选择' +
this.checkboxModel.length +
'项'
)
return false
}
if (this.checkboxModel.length > this.partyObj.voteMax) {
this.$vux.toast.text(
'请最多选择' +
this.partyObj.partyObj.voteMax +
'项，已选择' +
this.checkboxModel.length +
'项'
)
return false
}
this.voteForm()
},
voteForm () {
addVotePartyVotelog({
partyid: this.partyid,
voteids: this.checkboxModel.toString(),
openid: this.userid,
source: 1
}).then(data => {
this.$vux.toast.text('投票成功！')

operateCreditlist({
accountid: this.accountid,
rulecode: 'yzcytp',
credit: 1,
owner_type: this.$config.owner_type,
terminaltype: 2
}).then(res => {
this.loadList()
this.getCount()
})


})
},
detail (obj) {
this.scroll = document.documentElement.scrollTop || document.body.scrollTop
this.$router.push({
name: 'chuyidasaiDetail',
params: { voteid: obj.id }
})
},
search () {
this.page = 1
this.loadList()
this.mhsearch = false
},
showDialogFun (obj, index) {
this.dialogobj = obj
this.dialogobjIndex = index
this.showDialog = true
},

getCount () {
addCount({
partyid: this.partyid,
openid: this.userid
}).then(res => {
this.voteTotal = this.partyObj.voteMax - res.obj 
})
},
choose_search (item) {
console.log(item)
this.searchvalue = item
this.ischoose = true
this.search()
}
}
}
